import { Alert } from "src/components/ui";
import type { ReactNode } from "react";
import { useContext } from "react";
import { UNSAFE_DataRouterContext as DataRouterContext } from "react-router";
import { useAuthenticatedUser } from "src/contexts/AuthenticatedUserContext";
import { useRouteMetadata } from "src/hooks/useRouteMetadata";
import { hasRouteAccess } from "src/routes/metadata";

export default function RouteAccessBoundary({ children }: { children: ReactNode }) {
    const dataRouter = useContext(DataRouterContext);
    return dataRouter ? <RouteAccessBoundaryInner>{children}</RouteAccessBoundaryInner> : <>{children}</>;
}

function RouteAccessBoundaryInner({ children }: { children: ReactNode }) {
    const { permissions } = useAuthenticatedUser();
    const metadata = useRouteMetadata();
    if (!hasRouteAccess(metadata.access, permissions, metadata.params)) {
        return <Alert variant="warning" role="alert"><span>Permission Denied</span></Alert>;
    }
    return <>{children}</>;
}
